import AuthLayout from "../../layouts/Auth.layout";
import { AuthWrapper, VerifyForm } from "../../components/forms/auth";
import { VerifyProps } from "../../types";

export const Verify: React.FC<VerifyProps> = (props) => {
  return (
    <AuthLayout>
      <AuthWrapper form={<VerifyForm {...props} />}>
        <div className="font-poppins text-5xl	text-gray-500 mb-8">
          Verify it’s
          <br />
          you
        </div>
        <div className="font-manrope text-base text-gray-300 flex flex-row gap-x-6">
          Enter the code from your authenticator app
        </div>
      </AuthWrapper>
    </AuthLayout>
  );
};
